module.exports = __webpack_public_path__ + "static/media/v-logo-white.6470f6e9.png";